module.exports = __webpack_public_path__ + "img/cloud-meatball.d73f7eea.svg";